import { FormHelperText, Grid, Typography } from "@mui/material"
import React from "react"
import CrewCompositionCreationForm from "../CrewCompositionCreationForm"
import CompositionList from "../CompositionList"
import type { State } from "@hookstate/core";
import type { OptionType } from "~/components/SelectBasic";
import type IDevice from "~/features/Device/interfaces/IDevice";
import type IUser from "~/features/User/interfaces/IUser";
import type { CheckAvailabilityResponse, CrewList } from "../../interfaces";
import { useLang } from "~/hooks/useLang";

interface AssociateStaffProps {
  readonly crewPositionId: State<string | null>;
  readonly focusChange: State<boolean>;
  readonly resetValues: State<boolean>;
  readonly userId: State<number | null>;
  readonly device?: State<IDevice | null>;
  readonly crewPositionOptions: OptionType[];
  readonly crewList: State<CrewList[]>;
  readonly activeStep: State<number>;
  readonly checkAvailabilityResult?: State<CheckAvailabilityResponse | null>;
  readonly onAddCrewMember: (user: IUser, position: OptionType) => boolean;
  readonly disabledFields?: boolean;
}

export default function AssociateStaff({ crewPositionId,
  focusChange,
  resetValues,
  userId,
  crewPositionOptions,
  device,
  crewList,
  activeStep,
  checkAvailabilityResult,
  disabledFields,
  onAddCrewMember }: AssociateStaffProps) {
  const { translate } = useLang();

  return (
    <Grid container xs={12} display={'flex'} flexDirection={'column'} spacing={2}>
      <Grid item container xs={12} spacing={2}>
        <CrewCompositionCreationForm
          crewPositionId={crewPositionId}
          focusChange={focusChange}
          resetValues={resetValues}
          userId={userId}
          device={device}
          crewPositionOptions={crewPositionOptions}
          onAddCrewMember={onAddCrewMember}
          crewList={crewList}
          activeStep={activeStep}
          checkAvailabilityResult={checkAvailabilityResult}
          disabledFields={disabledFields}
        />
      </Grid>
      <Typography variant='caption' sx={{ marginLeft: 2, fontWeight: 'bold', marginTop: 1 }}>
        {translate(`Position crew required`, { positionName: crewPositionOptions[0].name })}
      </Typography>
      {Boolean(checkAvailabilityResult?.get()?.error) && activeStep.get() === 2 && (
        <FormHelperText error={Boolean(checkAvailabilityResult?.get()?.error)} sx={{ marginLeft: 2 }}>
          {checkAvailabilityResult?.get()?.error}
        </FormHelperText>
      )}
      <Grid item container xs={12}>
        <CompositionList crewList={crewList} />
      </Grid>
    </Grid>
  )
}